import { useEffect, useState } from 'react';
import { checkIsUserJoined } from '../../../../../common/checkRoleUser';
import { ROLE_ACCESS } from '../../../../../constant/storage';
import { PostContext } from '../../../../../context/PostContext';
import { IPost } from '../../../../../interfaces/post.interface';
import { FolderStatusEnum } from '../../../../../interfaces/training.interface';

const PostProvider = ({
  postInfo,
  children,
}: {
  postInfo: IPost;
  children: React.ReactNode;
}) => {
  const [lastSubmittedAt, setLastSubmittedAt] = useState<string | null>(
    postInfo.lastSubmittedAt
  );

  useEffect(() => {
    setLastSubmittedAt(postInfo.lastSubmittedAt);
  }, [postInfo.lastSubmittedAt]);

  return (
    <PostContext.Provider
      value={{
        ...postInfo,
        lastSubmittedAt,
        setLastSubmittedAt,
        defaultLastSubmittedAt: postInfo.lastSubmittedAt,
        isLocked: !postInfo.group
          ? false
          : postInfo.group.status == FolderStatusEnum.Private &&
            !checkIsUserJoined(postInfo.group.userRole as ROLE_ACCESS),
      }}
    >
      {children}
    </PostContext.Provider>
  );
};

export default PostProvider;
